const cityArticles = [
  {
    title: "Ahead of Homecoming, some Inwood residents say events held at Baker Athletics Complex inconvenience the community",
    author: "Surina Venkat, Lara Harmankaya",
    articleLink: "https://www.columbiaspectator.com/city-news/2025/10/16/ahead-of-homecoming-some-inwood-residents-say-events-held-at-baker-athletics-complex-inconvenience-the-community/",
    image: "https://www.columbiaspectator.com/resizer/v2/ETPNKULJTRHIPHIPAPGXD467MI.jpg?auth=558d2e8c3165ebda0abdb9ab4e2389b09d8a577fe0c7806daeb9a325d23a188c"
  }
];
export default cityArticles;
